import { getImageKitUrl } from '../util/utility';
import { decoratorFilters } from './Decorator/decoratorFilters';
import { destinationWeddingFilters } from './DestinationWeddings/destinationSearchPageFilters';
import { makeUpPageFilters } from './MakeUpArtist/MakeUpPageFilters';
import { mehendiArtistFilters } from './MehendiArtist/mehendiArtistFilters';
import { photographerPageFilters } from './photographers/photographerPageFilters';

export const CLOUDINARY_BUCKET_NAME = 'venuemonk-images';
// export const CLOUDINARY_SOURCE_IMAGE_URL = `https://res.cloudinary.com/venuemonk/image/upload/f_auto/${CLOUDINARY_BUCKET_NAME}`;
export const CLOUDINARY_SOURCE_IMAGE_URL = `https://res.cloudinary.com/venuemonk/image/upload/${CLOUDINARY_BUCKET_NAME}`;
export const AWS_SOURCE_IMAGE_URL = `https://cdn.venuemonk.com`;
export const AWS_RAW_SOURCE_IMAGE_URL = 'https://venuemonk-images.s3.ap-south-1.amazonaws.com';

export const IMAGEKIT_BUCKET_NAME = 'venuemonk';
export const IMAGEKIT_SOURCE_IMAGE_URL = `https://ik.imagekit.io/${IMAGEKIT_BUCKET_NAME}`;

export const GUMLET_SOURCE_IMAGE_URL = `https://vmnk.gumlet.io`;

export const VENUE_MANAGER_AGENT_DETAILS = {
    agent_name: 'Aishwarya Upadhyay',
    agent_contact_no: '7903189913',
    agent_profile_male: 'https://cdn.venuemonk.com/venuemonk-agent-two.png',
    agent_profile_female: 'https://cdn.venuemonk.com/venuemonk-agent.png',  
};


export const DUMMY_AGENT_CODE = 'ePzUd40zSP'

export const REST_API = 'REST_API';
export const ELASTIC_API = 'ELASTIC_API';
export const SEARCH_PAGE_API__TO_BE_USED = { REST_API: REST_API, ELASTIC_API: ELASTIC_API };
export const WHICH_SEARCH_SERVICE_TO_USE = SEARCH_PAGE_API__TO_BE_USED.ELASTIC_API;

export const VIDEOS = 'videos';
export const VIDEO = 'video';
export const IMAGE = 'image';
export const IMAGES = 'images';
export const CUSTOMER_IMAGE_SIZE_LIMIT = 10;
export const CUSTOMER_VIDEO_SIZE_LIMIT = 50;

export const VENUE_IMAGE_WATERMARK = 'tr:oi-50_opacity_eNv_2z4Oa.png,oh-50';

export const VM_LEADFORM__EVENT_TYPES = ['Corporate', 'Social', 'Wedding'];
export const haveuscallyouform_termsandconditiontext =
    'By Continuing I agree with the Terms of Use & Privacy Policy';

export const FILTER_TYPE_MIN_MAX = 'MinMaxSelect';

export const leadFormPaths = [
    '/get-quote',
    '/get-quotes-in-mumbai',
    '/get-quotes-for-destination',
    '/get-quotes-in-alwar',
    '/get-quotes-in-palwal',
    '/get-quotes-in-pushkar',
    '/get-quotes-in-delhi',
    '/get-quotes-in-faridabad',
    '/get-quotes-in-ghaziabad',
    '/get-quotes-in-gurgaon',
    '/get-quotes-in-jaipur',
    '/get-quotes-in-noida',
    '/get-quotes-for-destination-rajasthan',
    '/get-quotes-destination-in-jaipur',
    '/perfect-bridal-makeup-artists-delhi-ncr',
    '/write-reviews',
    '/review-win',
    '/login',
    '/sign-up',
    '/write-reviews/vendors',
    '/best-banquet-halls-in-faridabad',
    '/perfect-corporate-event-venues-in-delhi-ncr',
    '/perfect-corporate-event-venues-in-gurgaon',
    "/s"
];

export const PHOTOGRAPHER_MODEL = 'photographer';
export const MEHENDI_ARTIST_MODEL = 'mehandi_artist';
export const MAKE_UP_ARTIST_MODEL = 'makeup_artist';
export const DECORATOR_MODEL = 'decorator';
export const EVENT_PLANNER_MODEL = 'event_planner';
export const WEDDING_STYLIST_MODEL = 'wedding_stylist';
export const CATERERS_MODEL = 'caterer';
export const CHOREOGRAPHER_MODEL = 'choreographer';
export const DJ_MODEL = 'dj';
export const ANCHOR_MODEL = 'anchor';
export const WEDDING_ENTERTAINER_MODEL = 'wedding_entertainer';
export const PANDIT_MODEL = 'pandit';
export const CAR_MODEL = 'car';
export const BARTENDER_MODEL = 'bartender';
export const EVENT_EQUIPMENT_MODEL = 'event_equipment';

export const DESTINATION_WEDDING_MODEL = 'dw';

export const VENUE_MODEL = 'venue';

export const VENUE_FARIDABAD_STANDLONE = 'venue_faridabad_standalone';

export const VENUE_CORPORATE_STANALONE = 'venue_corporate_standalone'

export const VENUE_CORPORATE_STANALONE_GURGAON = 'venue_corporate_standalone_gurgaon'

export const MODELS = {
    [PHOTOGRAPHER_MODEL]: {
        display_name: 'Photographer',
        lead_type: 'photographer',
        search_page_code: 'p',
        route_code: 'photographer',
        event_key: 'isPhotographerNeeded',
        base_filters_route_code: 'photographer',
        vendor_page_code: 'photographer',
        filters: photographerPageFilters,
        DROPDOWN: [
            'min_price',
            'max_price',
            'min_reviews',
            'max_reviews',
            'min_rating',
            'max_rating',
            'max_days',
            'min_days',
        ],
        MULTI_SELECT: ['service_types', 'locations'],
        SINGLE_SELECT: ['sort'],
        IS_SELECTED: ['budget', 'reviews', 'days', 'rating'],
        search_page_venue_tile_image: `https://cdn.venuemonk.com/make_up_search_page_zero.png`,
    },
    [MEHENDI_ARTIST_MODEL]: {
        display_name: 'Mehandi Artist',
        lead_type: 'mehendi-artist',
        search_page_code: 'me',
        route_code: 'mehandi-artist',
        vendor_page_code: 'mehendi-artist',
        filters: mehendiArtistFilters,
        base_filters_route_code: 'mehendiArtist',
        event_key: 'isArtistNeeded',
        DROPDOWN: [
            'min_price',
            'max_price',
            'min_reviews',
            'max_reviews',
            'min_rating',
            'max_rating',
            'max_days',
            'min_days',
        ],
        MULTI_SELECT: ['service_types', 'locations'],
        SINGLE_SELECT: ['sort'],
        IS_SELECTED: ['budget', 'reviews', 'days', 'rating'],
        search_page_venue_tile_image: `https://cdn.venuemonk.com/mehendi_artist_search_page_zero.png`,
    },
    [MAKE_UP_ARTIST_MODEL]: {
        display_name: 'Makeup Artist',
        lead_type: 'makeup-artist',
        search_page_code: 'mu',
        route_code: 'makeup-artist',
        vendor_page_code: 'makeup-artist',
        base_filters_route_code: 'makeupartist',
        event_key: 'isArtistNeeded',
        filters: makeUpPageFilters,
        MULTI_SELECT: [
            'service_types',
            'locations',
            'services_speciality',
            'other_services_offered',
        ],
        SINGLE_SELECT: ['sort', 'siders_options', 'services_availabile_at'],
        IS_SELECTED: [
            'budget',
            'reviews',
            'experience',
            'rating',
            'services_speciality',
            'other_services_offered',
        ],
        DROPDOWN: [
            'min_price',
            'max_price',
            'min_reviews',
            'max_reviews',
            'min_rating',
            'max_rating',
            'min_experience',
            'max_experience',
            'siders_options',
            'services_availabile_at',
        ],
        search_page_venue_tile_image: `https://cdn.venuemonk.com/make_up_search_page_zero.png`,
    },
    [DECORATOR_MODEL]: {
        display_name: 'Decorator',
        lead_type: 'decorator',
        search_page_code: 'd',
        route_code: 'decorator',
        vendor_page_code: 'decorator',
        filters: decoratorFilters,
        base_filters_route_code: 'decorator',
        event_key: 'isArtistNeeded',
        DROPDOWN: [
            'min_price',
            'max_price',
            'min_reviews',
            'max_reviews',
            'min_rating',
            'max_rating',
            'max_days',
            'min_days',
        ],
        MULTI_SELECT: ['service_types', 'locations'],
        SINGLE_SELECT: ['sort'],
        IS_SELECTED: ['budget', 'reviews', 'days', 'rating'],
        search_page_venue_tile_image: `https://cdn.venuemonk.com/decorator_search_page_zero.png`,
    },
    [EVENT_PLANNER_MODEL]: {
        display_name: 'Event Planner',
        lead_type: 'event-planner',
        search_page_code: 'ep',
        route_code: 'event-planner',
        vendor_page_code: 'event-planner',
        filters: decoratorFilters,
        base_filters_route_code: 'eventplanner',
        event_key: 'isArtistNeeded',
        DROPDOWN: [
            'min_price',
            'max_price',
            'min_reviews',
            'max_reviews',
            'min_rating',
            'max_rating',
            'max_days',
            'min_days',
        ],
        MULTI_SELECT: ['service_types', 'locations'],
        SINGLE_SELECT: ['sort'],
        IS_SELECTED: ['budget', 'reviews', 'days', 'rating'],
        search_page_venue_tile_image: `https://cdn.venuemonk.com/decorator_search_page_zero.png`,
    },
    [WEDDING_STYLIST_MODEL]: {
        display_name: 'Wedding Stylist',
        lead_type: 'wedding-stylist',
        search_page_code: 'ws',
        route_code: 'wedding-stylist',
        vendor_page_code: 'wedding-stylist',
        filters: decoratorFilters,
        base_filters_route_code: 'weddingstylist',
        event_key: 'isArtistNeeded',
        DROPDOWN: [
            'min_price',
            'max_price',
            'min_reviews',
            'max_reviews',
            'min_rating',
            'max_rating',
            'max_days',
            'min_days',
        ],
        MULTI_SELECT: ['service_types', 'locations'],
        SINGLE_SELECT: ['sort'],
        IS_SELECTED: ['budget', 'reviews', 'days', 'rating'],
        search_page_venue_tile_image: `https://cdn.venuemonk.com/decorator_search_page_zero.png`,
    },
    [CATERERS_MODEL]: {
        display_name: 'Caterer',
        lead_type: 'caterer',
        search_page_code: 'c',
        route_code: 'caterer',
        vendor_page_code: 'caterer',
        filters: decoratorFilters,
        base_filters_route_code: 'caterer',
        event_key: 'isArtistNeeded',
        DROPDOWN: [
            'min_price',
            'max_price',
            'min_reviews',
            'max_reviews',
            'min_rating',
            'max_rating',
            'max_days',
            'min_days',
        ],
        MULTI_SELECT: ['service_types', 'locations'],
        SINGLE_SELECT: ['sort'],
        IS_SELECTED: ['budget', 'reviews', 'days', 'rating'],
        search_page_venue_tile_image: `https://cdn.venuemonk.com/decorator_search_page_zero.png`,
    },
    [CHOREOGRAPHER_MODEL]: {
        display_name: 'Choreographer',
        lead_type: 'choreographer',
        search_page_code: 'ch',
        route_code: 'choreographer',
        vendor_page_code: 'choreographer',
        filters: decoratorFilters,
        base_filters_route_code: 'choreographer',
        event_key: 'isArtistNeeded',
        DROPDOWN: [
            'min_price',
            'max_price',
            'min_reviews',
            'max_reviews',
            'min_rating',
            'max_rating',
            'max_days',
            'min_days',
        ],
        MULTI_SELECT: ['service_types', 'locations'],
        SINGLE_SELECT: ['sort'],
        IS_SELECTED: ['budget', 'reviews', 'days', 'rating'],
        search_page_venue_tile_image: `https://cdn.venuemonk.com/decorator_search_page_zero.png`,
    },
    [DJ_MODEL]: {
        display_name: 'Dj',
        lead_type: 'dj',
        search_page_code: 'dj',
        route_code: 'dj',
        vendor_page_code: 'dj',
        filters: decoratorFilters,
        base_filters_route_code: 'dj',
        event_key: 'isArtistNeeded',
        DROPDOWN: [
            'min_price',
            'max_price',
            'min_reviews',
            'max_reviews',
            'min_rating',
            'max_rating',
            'max_days',
            'min_days',
        ],
        MULTI_SELECT: ['service_types', 'locations'],
        SINGLE_SELECT: ['sort'],
        IS_SELECTED: ['budget', 'reviews', 'days', 'rating'],
        search_page_venue_tile_image: `https://cdn.venuemonk.com/decorator_search_page_zero.png`,
    },
    [ANCHOR_MODEL]: {
        display_name: 'Anchor',
        lead_type: 'anchor',
        search_page_code: 'ac',
        route_code: 'anchor',
        vendor_page_code: 'anchor',
        filters: decoratorFilters,
        base_filters_route_code: 'anchor',
        event_key: 'isArtistNeeded',
        DROPDOWN: [
            'min_price',
            'max_price',
            'min_reviews',
            'max_reviews',
            'min_rating',
            'max_rating',
            'max_days',
            'min_days',
        ],
        MULTI_SELECT: ['service_types', 'locations'],
        SINGLE_SELECT: ['sort'],
        IS_SELECTED: ['budget', 'reviews', 'days', 'rating'],
        search_page_venue_tile_image: `https://cdn.venuemonk.com/decorator_search_page_zero.png`,
    },
    [WEDDING_ENTERTAINER_MODEL]: {
        display_name: 'Wedding Entertainer',
        lead_type: 'wedding_entertainer',
        search_page_code: 'we',
        route_code: 'wedding-entertainer',
        vendor_page_code: 'wedding-entertainer',
        filters: decoratorFilters,
        base_filters_route_code: 'weddingentertainer',
        event_key: 'isArtistNeeded',
        DROPDOWN: [
            'min_price',
            'max_price',
            'min_reviews',
            'max_reviews',
            'min_rating',
            'max_rating',
            'max_days',
            'min_days',
        ],
        MULTI_SELECT: ['service_types', 'locations'],
        SINGLE_SELECT: ['sort'],
        IS_SELECTED: ['budget', 'reviews', 'days', 'rating'],
        search_page_venue_tile_image: `https://cdn.venuemonk.com/decorator_search_page_zero.png`,
    },
    [PANDIT_MODEL]: {
        display_name: 'Pandit',
        lead_type: 'pandit',
        search_page_code: 'pt',
        route_code: 'pandit',
        vendor_page_code: 'pandit',
        filters: decoratorFilters,
        base_filters_route_code: 'pandit',
        event_key: 'isArtistNeeded',
        DROPDOWN: [
            'min_price',
            'max_price',
            'min_reviews',
            'max_reviews',
            'min_rating',
            'max_rating',
            'max_days',
            'min_days',
        ],
        MULTI_SELECT: ['service_types', 'locations'],
        SINGLE_SELECT: ['sort'],
        IS_SELECTED: ['budget', 'reviews', 'days', 'rating'],
        search_page_venue_tile_image: `https://cdn.venuemonk.com/decorator_search_page_zero.png`,
    },
    [CAR_MODEL]: {
        display_name: 'Car',
        lead_type: 'car',
        search_page_code: 'ca',
        route_code: 'car',
        vendor_page_code: 'car',
        filters: decoratorFilters,
        base_filters_route_code: 'car',
        event_key: 'isArtistNeeded',
        DROPDOWN: [
            'min_price',
            'max_price',
            'min_reviews',
            'max_reviews',
            'min_rating',
            'max_rating',
            'max_days',
            'min_days',
        ],
        MULTI_SELECT: ['service_types', 'locations'],
        SINGLE_SELECT: ['sort'],
        IS_SELECTED: ['budget', 'reviews', 'days', 'rating'],
        search_page_venue_tile_image: `https://cdn.venuemonk.com/decorator_search_page_zero.png`,
    },
    [BARTENDER_MODEL]: {
        display_name: 'Bartender',
        lead_type: 'bartender',
        search_page_code: 'ba',
        route_code: 'bartender',
        vendor_page_code: 'bartender',
        filters: decoratorFilters,
        base_filters_route_code: 'bartender',
        event_key: 'isArtistNeeded',
        DROPDOWN: [
            'min_price',
            'max_price',
            'min_reviews',
            'max_reviews',
            'min_rating',
            'max_rating',
            'max_days',
            'min_days',
        ],
        MULTI_SELECT: ['service_types', 'locations'],
        SINGLE_SELECT: ['sort'],
        IS_SELECTED: ['budget', 'reviews', 'days', 'rating'],
        search_page_venue_tile_image: `https://cdn.venuemonk.com/decorator_search_page_zero.png`,
    },
    [EVENT_EQUIPMENT_MODEL]: {
        display_name: 'Event Eqipment',
        lead_type: 'event_equipment',
        search_page_code: 'eq',
        route_code: 'event-equipment',
        vendor_page_code: 'event-equipment',
        filters: decoratorFilters,
        base_filters_route_code: 'eventequipment',
        event_key: 'isArtistNeeded',
        DROPDOWN: [
            'min_price',
            'max_price',
            'min_reviews',
            'max_reviews',
            'min_rating',
            'max_rating',
            'max_days',
            'min_days',
        ],
        MULTI_SELECT: ['service_types', 'locations'],
        SINGLE_SELECT: ['sort'],
        IS_SELECTED: ['budget', 'reviews', 'days', 'rating'],
        search_page_venue_tile_image: `https://cdn.venuemonk.com/decorator_search_page_zero.png`,
    },
    [DESTINATION_WEDDING_MODEL]: {
        display_name: 'Destination Wedding',
        lead_type: 'dw',
        search_page_code: 'dw',
        route_code: 'venues', // todo mokshit to change
        filters: destinationWeddingFilters,
        base_filters_route_code: 'DestinationWedding',
        event_key: '',
        DROPDOWN: [
            'min_price_with_guests',
            'max_price_with_guests',
            'min_capacity',
            'max_capacity',
            'min_room_count',
            'max_room_count',
        ],
        MULTI_SELECT: ['venuetypes', 'operating_cities'],
        SINGLE_SELECT: ['occasions', 'packagetypes', 'availability'],
        MIN_MAX: ['price', 'capacity', 'rooms'],
        DESKTOP_TOP_FILTERS: ['operating_cities', 'venuetypes', 'localities', 'price'], // Add according to sorted order
        MOBILE_TOP_FILTERS: [
            'operating_cities',
            'venuetypes',
            'price',
            'rooms',
            'occasions',
            'packagetypes',
            'capacity',
        ],
        MOBILE_OVERLAY_FILTERS: [
            'operating_cities',
            'venuetypes',
            'availability',
            'localities',
            'price',
            'occasions',
            'packagetypes',
            'capacity',
        ],
        search_page_venue_tile_image: `https://cdn.venuemonk.com/decorator_search_page_zero.png`,
        base_search_page_url: 'destination-wedding-venues',
    },
    [VENUE_MODEL]: {
        lead_type: 'venue',
    },
    [VENUE_CORPORATE_STANALONE]: {
        lead_type: 'corporate-standalone',
    },
    [VENUE_CORPORATE_STANALONE_GURGAON]: {
        lead_type: 'corporate-standalone',
    },
};

export const VendorDropdown = [
    {
        categoryId: 'Vendors',
        categoryName: 'Vendors',
        _id: '5b28afdcb92a94005379eb90',
        dropdownType: 'vendors-text',
        name: 'vendorsDropdown',
        title: 'Vendors',
        isImageAbove: false,
        list: [
            {
                _id: '5b28afdcb92a94005379eb0f',
                name: 'Photographers',
                link: '/photographers-in-delhi-ncr/p',
                icon: 'vm_photographer_icon',
                title: 'Photographers',
                // maginLeft:"4px"
            },
            {
                _id: '5b28afdcb92a94005379eb0e',
                name: 'Makeup Artists',
                link: '/bridal-makeup-artists/mu',
                icon: 'vm_makeup_artist_icon',
                title: 'Makeup Artists',
                // "fontsize":"20px",
                maginLeft: '2px',
            },
            // {
            //     _id: '5b28afdcb92a94005379eb0d',
            //     name: 'Mehendi Artists',
            //     link: '/mehendi-artist-in-delhi-ncr/me',
            //     icon: 'vm_mehendi_artist_icon',
            //     fontsize: '24px',
            // },
            // {
            //     _id: '5b28afdcb92a94005379eb0c',
            //     name: 'Decorators',
            //     link: '/decorator-in-delhi-ncr/d',
            //     icon: 'vm_decorator_icon',
            //     // "fontsize":"20px"
            // },
        ],
    },
];

export const cityMap = {
    mumbai: 'mumbai',
    noida: 'noida',
    delhi: 'delhi',
    ghaziabad: 'ghaziabad',
    gurgaon: 'gurgaon',
    faridabad: 'faridabad',
    jaipur: 'jaipur',
    pushkar: 'pushkar',
    alwar: 'alwar',
    palwal: 'palwal',
    'delhi-ncr': 'gurgaon',
 };


export const WRITE_REVIEW_DESCRIPTION = "Let others know what you thought of your event!"